module.exports = __webpack_public_path__ + "img/Myo.5fdb7fcc.png";